import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import sv from 'vuetify/es5/locale/sv'

Vue.use(Vuetify)

const options = {}

const theme = {
  themes: {
    light: {
      primary: '#21ba45',
      accent: '#21ba45'
    }
  }
}

const lang = {
  locales: { sv },
  current: 'sv'
}

export default new Vuetify({
  options,
  theme,
  lang
})
